<app-onboarding-ui [currentStep]="currentStep"></app-onboarding-ui>
